/**
 * Computes the set of gap types for a trip.
 *
 * Returns a subset of ['hotel', 'transport']:
 * - Empty when the trip has no flights
 * - 'hotel' when the trip has flights but no hotels
 * - 'transport' when the trip has flights but no car rentals
 *
 * Dining is intentionally excluded from gap detection to match legacy semantics.
 *
 * @param {Object} trip - The trip object
 * @returns {string[]} Array of gap type strings
 */
export function computeTripGaps(trip) {
  if (!trip?.flights?.length) return [];
  const gaps = [];
  if (!trip.hotels?.length) gaps.push('hotel');
  if (!trip.carRentals?.length) gaps.push('transport');
  return gaps;
}
